import { useQuery, UseQueryResult } from 'react-query';

import {
  MunicipalityBlackListDto,
  PaginatedNameFilterOptions,
  PaginatedList,
} from '@project/types';
import { municipalityBlackListApiService } from '@project/services';

export const useMunicipalityBlackListData = (
  filterOptions: PaginatedNameFilterOptions,
): UseQueryResult<PaginatedList<MunicipalityBlackListDto>, unknown> =>
  useQuery(['municipality-black-list', filterOptions], () =>
    municipalityBlackListApiService.getMunicipalityBlackList(filterOptions),
  );
